<app-crud-edit [apiService]="materiasService" [fields]="fields" [title]="'materia'" [description]="'En esta sección podrás editar el detalle de la Materia'"></app-crud-edit>
